import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { toast } from "sonner";
import { Plus, Edit3, Trash2, X } from "lucide-react";

const EMPTY = { title: "", description: "", icon: "hammer", order: 0 };
const ICONS = ["hammer", "building", "hand-coins", "trending-up"];

export default function AdminServices() {
  const [services, setServices] = useState([]);
  const [editing, setEditing] = useState(null);
  const [form, setForm] = useState(EMPTY);

  const load = () => api.get("/services").then((r) => setServices(r.data)).catch(() => {});
  useEffect(() => { load(); }, []);

  const openNew = () => { setEditing("new"); setForm({ ...EMPTY, order: services.length + 1 }); };
  const openEdit = (s) => { setEditing(s.id); setForm({ ...EMPTY, ...s }); };
  const close = () => { setEditing(null); setForm(EMPTY); };

  const save = async () => {
    if (!form.title.trim()) { toast.error("Başlık zorunlu"); return; }
    try {
      if (editing === "new") await api.post("/services", form);
      else await api.put(`/services/${editing}`, form);
      toast.success("Kaydedildi");
      close();
      load();
    } catch (err) {
      toast.error("Hata: " + (err.response?.data?.detail || err.message));
    }
  };

  const remove = async (id) => {
    if (!window.confirm("Hizmet silinsin mi?")) return;
    try { await api.delete(`/services/${id}`); toast.success("Silindi"); load(); }
    catch { toast.error("Silme hatası"); }
  };

  return (
    <div className="p-8 lg:p-12" data-testid="admin-services-page">
      <div className="flex items-center justify-between mb-10">
        <div>
          <div className="section-label mb-3">Hizmet Yönetimi</div>
          <h1 className="font-heading text-3xl lg:text-4xl text-white tracking-[0.05em]">Hizmetler ({services.length})</h1>
        </div>
        <button onClick={openNew} className="btn-gold text-xs" data-testid="add-service-btn"><Plus className="w-4 h-4" /> Yeni Hizmet</button>
      </div>

      <div className="grid gap-3">
        {services.map((s) => (
          <div key={s.id} className="yk-card p-6 flex items-center gap-4" data-testid={`service-row-${s.id}`}>
            <div className="w-12 h-12 border border-[#C9A961]/40 flex items-center justify-center text-[#C9A961] text-xs uppercase tracking-widest">#{s.order}</div>
            <div className="flex-1 min-w-0">
              <div className="text-white font-semibold uppercase tracking-widest text-sm mb-1">{s.title}</div>
              <div className="text-white/50 text-sm truncate">{s.description}</div>
            </div>
            <div className="text-[10px] text-white/40 uppercase tracking-widest">{s.icon}</div>
            <button onClick={() => openEdit(s)} className="p-2 text-white/60 hover:text-[#C9A961]"><Edit3 className="w-4 h-4" /></button>
            <button onClick={() => remove(s.id)} className="p-2 text-white/60 hover:text-red-400"><Trash2 className="w-4 h-4" /></button>
          </div>
        ))}
      </div>

      {editing && (
        <div className="fixed inset-0 bg-black/80 z-50 flex items-center justify-center p-4" onClick={close}>
          <div className="bg-[#0A0E1A] border border-[#1F2937] max-w-2xl w-full" onClick={(e) => e.stopPropagation()}>
            <div className="p-8 border-b border-[#1F2937] flex justify-between items-center">
              <h2 className="font-heading text-2xl text-white tracking-widest">{editing === "new" ? "Yeni Hizmet" : "Hizmeti Düzenle"}</h2>
              <button onClick={close} className="text-white/60 hover:text-white"><X className="w-5 h-5" /></button>
            </div>
            <div className="p-8 space-y-5">
              <div>
                <label className="text-xs uppercase tracking-[0.2em] text-[#C9A961] block mb-2">Başlık *</label>
                <input type="text" className="yk-input" value={form.title} onChange={(e) => setForm({ ...form, title: e.target.value })} data-testid="service-title-input" />
              </div>
              <div>
                <label className="text-xs uppercase tracking-[0.2em] text-[#C9A961] block mb-2">Açıklama</label>
                <textarea rows={3} className="yk-input resize-none" value={form.description} onChange={(e) => setForm({ ...form, description: e.target.value })} />
              </div>
              <div className="grid grid-cols-2 gap-4">
                <div>
                  <label className="text-xs uppercase tracking-[0.2em] text-[#C9A961] block mb-2">İkon</label>
                  <select className="yk-input" value={form.icon} onChange={(e) => setForm({ ...form, icon: e.target.value })}>
                    {ICONS.map((i) => <option key={i} value={i}>{i}</option>)}
                  </select>
                </div>
                <div>
                  <label className="text-xs uppercase tracking-[0.2em] text-[#C9A961] block mb-2">Sıra</label>
                  <input type="number" className="yk-input" value={form.order} onChange={(e) => setForm({ ...form, order: parseInt(e.target.value) || 0 })} />
                </div>
              </div>
              <div className="flex gap-3">
                <button onClick={save} className="btn-gold flex-1" data-testid="save-service-btn">Kaydet</button>
                <button onClick={close} className="btn-gold-outline flex-1">İptal</button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
